<script setup>
import { Loc } from 'main.core';
import { computed } from 'ui.vue3';
import { storeToRefs } from 'ui.vue3.pinia';
import CalculatorParam from './CalculatorParam.vue';
import InfoBlock from './InfoBlock.vue';
import NumberInput from './NumberInput.vue';
import useCalculatorStore from '../store/calculator.js';

const calculator = useCalculatorStore();
const { selectedGroup, tariff } = storeToRefs(calculator);

const info = computed(() => {
  let info = '';
  const group = tariff.value?.groups.find(g => g.group_id === selectedGroup.value?.id);
  if (tariff.value?.included_bases > 0) {
    info = Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_INFO_BASES_INCLUDED', {
      '#AMOUNT#': tariff.value.included_bases,
    });
    if (group && group.price_per_base) {
      info += Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_INFO_BASES_ADDITIONAL', {
        '#PRICE#': Intl.NumberFormat().format(group.price_per_base),
      });
    }
  } else if (group && group.price_per_base) {
    info = Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_INFO_BASES_PRICE', {
      '#PRICE#': Intl.NumberFormat().format(group.price_per_base),
    });
  }
  return info;
});
</script>

<template>
  <CalculatorParam>
    <template #title>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_BASES') }}
    </template>
    <template #subtitle>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_BASES_HINT') }}
    </template>
    <NumberInput
      v-model="calculator.selectedBases"
      :label="Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_LABEL_BASES')"
    />
    <template #information>
      <InfoBlock v-if="info" :modifiers="['mark', 'info']">
        {{ info }}
      </InfoBlock>
    </template>
  </CalculatorParam>
</template>
